import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollManager() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        const NAVBAR_OFFSET =
            document.getElementById("navbar")?.offsetHeight || 0;
        if (hash) {
            const id = hash.replace("#", "");

            const scrollToHash = () => {
                const el = document.getElementById(id);
                if (el) {
                    const y =
                        el.getBoundingClientRect().top +
                        window.scrollY -
                        NAVBAR_OFFSET;

                    window.scrollTo({ top: y, behavior: "smooth" });
                } else {
                    requestAnimationFrame(scrollToHash);
                }
            };

            scrollToHash();
        } else {
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }
    }, [pathname, hash]);

    return null;
}
